"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _galleryCarouselPropTypes = require("./gallery-carousel-prop-types");

var _galleryCarouselNav = _interopRequireDefault(require("./gallery-carousel-nav"));

var _galleryCarouselHero = _interopRequireDefault(require("./gallery-carousel-hero"));

var _svg = _interopRequireDefault(require("../svg"));

require("./gallery-carousel.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @typedef {object} GalleryCarouselItemData
 * @property {string} id Unique id for image
 * @property {string} heroUrl Image url
 * @property {string} heroPlaceholderUrl Placeholder URL, image is lazy loaded if provided
 * @property {string} heroNavTitle Title of the image
 * @property {string} description Markdown description of the large image
 */

/**
 * @typedef {object} GalleryCarouselProps
 * @property {GalleryCarouselItemData[]} data List of image data
 */

/**
 * @typedef {object} GalleryCarouselState
 * @property {GalleryCarouselItemData} previousImage Image behind the current image
 * @property {string} currentTitle Item selected by the child carousel
 * @property {boolean} showSpinner Whether to display the loading spinner
 * @property {GalleryCarouselItemData} currentImage Image to fade in on top of the last image
 * @property {object} currentImageStyle Style object used for fade in effect on top image
 * @property {boolean} lazy Whether to lazy load the image. This is true for the initial image
 * and false after the user interacts with the carousel
 */

/**
 * Creates a carousel navigation for the gallery using their image titles
 * @class
 * @extends {React.Component<GalleryCarouselProps, GalleryCarouselState>}
 */
var GalleryCarousel = /*#__PURE__*/function (_React$Component) {
  _inherits(GalleryCarousel, _React$Component);

  var _super = _createSuper(GalleryCarousel);

  /**
   * @param {GalleryCarouselProps} props
   */
  function GalleryCarousel(props) {
    var _this;

    _classCallCheck(this, GalleryCarousel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChange", function (imageId) {
      _this.setState({
        currentTitle: imageId,
        lazy: false
      }, function () {
        var selectedImage = _this.getSelectedImage();

        if (selectedImage) {
          _this.loadImage(selectedImage.heroUrl);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateImages", function () {
      var currentImage = _this.state.currentImage;

      var selectedImage = _this.getSelectedImage();

      if (!selectedImage) {
        return;
      }

      clearTimeout(_this.showSpinnerTimeout);

      _this.setState({
        previousImage: currentImage || selectedImage,
        showSpinner: false,
        currentImage: selectedImage,
        currentImageStyle: {
          opacity: '0'
        }
      });

      clearTimeout(_this.styleTimeout);
      _this.styleTimeout = setTimeout(function () {
        _this.setState({
          currentImageStyle: {
            opacity: '1',
            transition: 'opacity 0.3s'
          }
        });
      }, 100);
    });

    _this.showSpinnerTimeout = null;
    _this.styleTimeout = null;
    /** The image instance is used to load and cache images before we fade them into view */

    if (GalleryCarousel.imageConstructorExists()) {
      _this.image = new Image();
      _this.image.onload = _this.updateImages;
      _this.image.onerror = _this.updateImages;
    }

    _this.state = {
      previousImage: props.data[0] || null,
      currentTitle: props.data[0] ? props.data[0].id : null,
      showSpinner: false,
      currentImage: props.data[0] || null,
      currentImageStyle: {},
      lazy: true
    };
    return _this;
  }

  _createClass(GalleryCarousel, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.showSpinnerTimeout);
      clearTimeout(this.styleTimeout);
    }
  }, {
    key: "getSelectedImage",
    value: function getSelectedImage() {
      var data = this.props.data;
      var currentTitle = this.state.currentTitle;
      return data.find(function (i) {
        return i.id === currentTitle;
      });
    }
    /**
     * @param {string} imageId
     */

  }, {
    key: "loadImage",
    value:
    /**
     * Load a new image and fade it in on top of the previous one
     * @param {string} url
     */
    function loadImage(url) {
      var _this2 = this;

      clearTimeout(this.showSpinnerTimeout);
      this.showSpinnerTimeout = setTimeout(function () {
        return _this2.setState({
          showSpinner: true
        });
      }, GalleryCarousel.showSpinnerWait);
      this.image.src = '';
      this.image.src = url;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          previousImage = _this$state.previousImage,
          currentImage = _this$state.currentImage,
          currentImageStyle = _this$state.currentImageStyle,
          currentTitle = _this$state.currentTitle,
          showSpinner = _this$state.showSpinner,
          lazy = _this$state.lazy;
      var data = this.props.data;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "GalleryCarousel"
      }, /*#__PURE__*/_react["default"].createElement(_galleryCarouselNav["default"], {
        onChange: this.onChange,
        currentTitle: currentTitle,
        data: data.map(GalleryCarousel.toCarouselImage)
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hero-container"
      }, /*#__PURE__*/_react["default"].createElement(_galleryCarouselHero["default"], {
        image: previousImage,
        lazy: lazy,
        style: {}
      }), /*#__PURE__*/_react["default"].createElement(_galleryCarouselHero["default"], {
        image: currentImage,
        lazy: lazy,
        style: currentImageStyle
      })), showSpinner ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "loading"
      }, /*#__PURE__*/_react["default"].createElement(_svg["default"], {
        id: "spinner"
      })) : null);
    }
  }], [{
    key: "toCarouselImage",
    value:
    /**
     * Convert gallery image data to carousel image data
     * @param {GalleryCarouselItemData} image
     */
    function toCarouselImage(_ref) {
      var id = _ref.id,
          heroNavTitle = _ref.heroNavTitle;
      return {
        id: id,
        title: heroNavTitle
      };
    }
  }]);

  return GalleryCarousel;
}(_react["default"].Component);

_defineProperty(GalleryCarousel, "windowExists", function () {
  return typeof window !== 'undefined';
});

_defineProperty(GalleryCarousel, "imageConstructorExists", function () {
  return typeof Image !== 'undefined';
});

_defineProperty(GalleryCarousel, "propTypes", {
  data: _propTypes["default"].arrayOf(_galleryCarouselPropTypes.imagePropType).isRequired
});

_defineProperty(GalleryCarousel, "showSpinnerWait", 300);

var _default = GalleryCarousel;
exports["default"] = _default;